//app.js
import React from 'react';
import FrameRouter from './router/FrameRouter';

import Config from './config/Config';
import Widget from './widget/Widget';
import './iconfont/iconfont.css'
import  './css/frame.css';
// import 'antd/dist/antd.css'
import './App.css';

class App extends React.Component 
{
	constructor( props )
	{
		super(props);

		this.state = {
			classComponent:Config.getClassComponent()
		}
	}
	componentDidMount()
	{
		this.loadTitle();

		Widget.loadClass();

		this.setFavicon();
	}

	loadTitle = () => {
		document.title = Config.getSystemTitle();
	}

	setFavicon = () => {
		const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'shortcut icon';
		link.href =  window.location.origin + "/" + Config.getSystemFavicon();
		document.getElementsByTagName('head')[0].appendChild(link);
	};
   
	render() 
	{
		const { classComponent } = this.state;
		return (
			<div style={{width:'100%', height:'100vh'}} component-data={classComponent} >
				<FrameRouter />
			</div>
		)	
	}
}

export default App;